import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import bankService from "../../services/bankService";

export const fetchBanks=createAsyncThunk(
    "banks/fetch",
    async()=>{

        return await bankService.getBanks();

    }
);

export const removeBank=createAsyncThunk(
    "banks/delete",
    async(id)=>{

        await bankService.deleteBank(id);

        return id;

    }
);

export const addBank = createAsyncThunk(
    "banks/add",
    async (formData, thunkAPI) => {
        try {
            return await bankService.addBank(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const bankSlice=createSlice({

    name:"banks",

    initialState:{
        banks:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchBanks.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchBanks.fulfilled,(state,action)=>{
    state.loading=false;
    state.banks=action.payload;
})

.addCase(fetchBanks.rejected,(state)=>{
    state.loading=false;
})

.addCase(addBank.fulfilled,(state,action)=>{

    state.banks.unshift(action.payload);

})

.addCase(removeBank.fulfilled,(state,action)=>{

    state.banks=
    state.banks.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default bankSlice.reducer;